/** Traductions modal modification commande (FR / AR) */
export const editOrderModalFr = {
  errDataTitle: 'Erreur de données',
  errQtyPrice: 'La quantité et le prix doivent être supérieurs à zéro',
  title: 'Modifier Commande',
  productLabel: 'Produit *',
  selectProduct: 'Sélectionner Produit',
  statusLabel: 'Statut',
  statusEnRoute: 'En Route',
  statusDelivered: 'Livré',
  statusCancelled: 'Annulé',
  totalColon: 'Total :',
  updateOrder: 'Mettre à jour Commande'
};

export const editOrderModalAr = {
  errDataTitle: 'خطأ في البيانات',
  errQtyPrice: 'الكمية والسعر يجب أن يكونا أكبر من صفر',
  title: 'تعديل الطلب',
  productLabel: 'المنتج *',
  selectProduct: 'اختر المنتج',
  statusLabel: 'الحالة',
  statusEnRoute: 'في الطريق',
  statusDelivered: 'تم التسليم',
  statusCancelled: 'ملغي',
  totalColon: 'الإجمالي:',
  updateOrder: 'تحديث الطلب'
};
